import React from 'react';
import { Box, Typography, Button, Stack, CircularProgress } from '@mui/material';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import LockIconWrapper from '../../../components/LockIconWrapper';

function WaitingForPaymentBanner({
  onConvertToOffline,
  onCancelPayments,
  convertingPayment,
  hasUpdateRights,
  isActionable = false,
}) {
  const buttonsDisabled = !isActionable || convertingPayment || !hasUpdateRights;
  return (
    <Box
      sx={{
        mb: 2,
        p: 3,
        backgroundColor: 'error.main',
        borderRadius: 2,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
        <RunningWithErrorsIcon sx={{ fontSize: 40, color: 'white' }} />
        <Typography variant='h6' sx={{ color: 'white', fontWeight: 'bold' }}>
          Diese Buchung beinhaltet unbezahlte Online-Zahlungen. Wie soll damit verfahren werden?
        </Typography>
      </Box>
      <Stack direction='row' spacing={2}>
        <Button
          variant='contained'
          color='inherit'
          size='large'
          sx={{
            backgroundColor: 'white',
            color: 'error.main',
            '&:hover': {
              backgroundColor: 'grey.100',
            },
            minWidth: 200,
          }}
          onClick={onConvertToOffline}
          disabled={buttonsDisabled}
          startIcon={convertingPayment ? <CircularProgress size={24} color='inherit' /> : null}
        >
          <LockIconWrapper right={'internalBooking:update:own'}>
            {convertingPayment ? 'Wird konvertiert...' : 'Zu Offline-Zahlung konvertieren'}
          </LockIconWrapper>
        </Button>
        <Button
          variant='outlined'
          color='inherit'
          size='large'
          sx={{
            borderColor: 'white',
            color: 'white',
            '&:hover': {
              borderColor: 'white',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
            minWidth: 200,
          }}
          onClick={onCancelPayments}
          disabled={buttonsDisabled}
        >
          <LockIconWrapper right={'internalBooking:update:own'}>Buchung stornieren</LockIconWrapper>
        </Button>
      </Stack>
    </Box>
  );
}

export default WaitingForPaymentBanner;
